import {
  camelCase,
  cloneDeep,
  compact,
  differenceBy,
  differenceWith,
  groupBy,
  isEmpty,
  isEqual,
  isMatch,
  lowerCase,
  round,
  sortBy,
  startCase,
  toUpper,
  union,
  upperFirst
} from 'lodash'
import { evaluate } from 'mathjs'
import moment from 'moment'
import Vue from 'vue'

import {
  handleValidateAndFormatNumber,
  preventNonNumber,
  preventNonNumberDecimal
} from '@/utils/inputFormatter'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

/* Styles import */
import '@/assets/styles/tailwind.css'
import '@/assets/styles/_global.scss'
/* Plugins import */
import '@/plugins/VuesaxConfig'
import '@/plugins/VeeValidateConfig'
import '@/plugins/Vue2Datepicker'
import '@/plugins/VueMetaConfig'
import '@/plugins/VueAutonumericConfig'
import '@/plugins/VueMultiSelectConfig'
import '@/plugins/OidcPlugin'
import '@/plugins/Chart'
import '@/plugins/ExcelEditorPlugin'

import {
  closePageLoading,
  showFailedNotification,
  showPageLoading,
  showSuccessNotification,
  showWarningNotification
} from '@/utils/cosmeticsUtils'
import {
  isUserCanAccessChildMenu,
  isUserCanAccessFeature,
  isUserCanAccessGrandchildMenu,
  isUserCanAccessMenu
} from '@/utils/permissionUtils'

Vue.mixin({
  methods: {
    moment,
    isEmpty,
    isEqual,
    isMatch,
    lowerCase,
    differenceBy,
    differenceWith,
    startCase,
    toUpper,
    camelCase,
    union,
    compact,
    groupBy,
    cloneDeep,
    // `sortBy` method conflicted with `sortBy` props on component
    loSortBy: sortBy,
    // `round` method conflicted with vuesax `round` props on `vs-icon`
    loRound: round,
    upperFirst,
    evaluate,
    showPageLoading,
    closePageLoading,
    showSuccessNotification,
    showFailedNotification,
    showWarningNotification,
    isUserCanAccessMenu,
    isUserCanAccessChildMenu,
    isUserCanAccessGrandchildMenu,
    isUserCanAccessFeature,
    preventNonNumber,
    preventNonNumberDecimal,
    handleValidateAndFormatNumber
  },
  data() {
    return {
      globalNumericOptions: {
        allowDecimalPadding: false,
        decimalCharacterAlternative: '.',
        roundingMethod: 'U',
        minimumValue: '0',
        modifyValueOnWheel: false
      }
    }
  }
})

new Vue({
  router,
  store,
  render: component => component(App)
}).$mount('#app')
